import { ActionIcon, Group, Tooltip } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconCheck, IconX } from "@tabler/icons-react";
import InterestActionConfirmModal from "@/pages/interests/components/InterestActionConfirmModal";

type InterestIconDecisionButtonsProps = {
  acceptLabel: string;
  acceptTitle: string;
  acceptMessage: string;
  rejectLabel: string;
  rejectTitle: string;
  rejectMessage: string;
  onAccept: () => void;
  onReject: () => void;
  isLoading?: boolean;
  size?: "sm" | "md" | "lg";
};

export default function InterestIconDecisionButtons({
  acceptLabel,
  acceptTitle,
  acceptMessage,
  rejectLabel,
  rejectTitle,
  rejectMessage,
  onAccept,
  onReject,
  isLoading = false,
  size = "lg",
}: InterestIconDecisionButtonsProps) {
  const [acceptOpened, { open: openAccept, close: closeAccept }] = useDisclosure(false);
  const [rejectOpened, { open: openReject, close: closeReject }] = useDisclosure(false);

  return (
    <>
      <Group gap={6} wrap="nowrap">
        <Tooltip label={acceptLabel}>
          <ActionIcon
            variant="light"
            color="teal"
            size={size}
            radius="md"
            aria-label={acceptLabel}
            onClick={openAccept}
            loading={isLoading}
          >
            <IconCheck size={18} />
          </ActionIcon>
        </Tooltip>
        <Tooltip label={rejectLabel}>
          <ActionIcon
            variant="light"
            color="red"
            size={size}
            radius="md"
            aria-label={rejectLabel}
            onClick={openReject}
            loading={isLoading}
          >
            <IconX size={18} />
          </ActionIcon>
        </Tooltip>
      </Group>

      <InterestActionConfirmModal
        opened={acceptOpened}
        onClose={closeAccept}
        title={acceptTitle}
        message={acceptMessage}
        confirmLabel="Yes, accept"
        confirmColor="teal"
        isLoading={isLoading}
        onConfirm={() => {
          closeAccept();
          onAccept();
        }}
      />

      <InterestActionConfirmModal
        opened={rejectOpened}
        onClose={closeReject}
        title={rejectTitle}
        message={rejectMessage}
        confirmLabel="Yes, reject"
        confirmColor="red"
        isLoading={isLoading}
        onConfirm={() => {
          closeReject();
          onReject();
        }}
      />
    </>
  );
}
